import React from 'react';
import { Button } from '../../../../../../../../components/Common/UI/Button';
import { cn } from '../../../../../../../../utils/styles';
import { useMessageManagerProvider } from '../../../../../../../context/messageManager';
import Icons from '../../../../../../../../components/Common/Icons/Icons';

function TabsNavigation() {
  const { activeTab, handleActiveTab, handleHideEndOfStatement, hideEndOfStatement } = useMessageManagerProvider();

  return (
    <div className="flex">
      <Button
        className={cn('px-[20px] rounded-none', {
          'bg-primary text-primary-foreground': activeTab === 0,
        })}
        onClick={() => {
          handleActiveTab(0);
        }}
        variant="secondary"
      >
        Statement
      </Button>
      {!hideEndOfStatement ? (
        <Button
          className={cn('px-[20px] rounded-none flex gap-[10px] justify-between items-center', {
            'bg-primary text-primary-foreground': activeTab === 1,
          })}
          onClick={() => handleActiveTab(1)}
          variant="secondary"
        >
          End of Statement
          <Icons.CloseIcon
            className="[&_path]:fill-white [&_rect]:fill-transparent w-[22px] h-[22px]"
            onClick={e => {
              e.stopPropagation();
              handleHideEndOfStatement();
            }}
          />
        </Button>
      ) : null}
    </div>
  );
}

export default TabsNavigation;
